import { PreviewFile } from "../../../components";
import { dateToHumanFormat } from "../../../utils/constants";
import { HugeiconsIcon } from '@hugeicons/react';
import { CheckmarkCircle01Icon, Cancel01Icon } from '@hugeicons/core-free-icons';

const employmentLabels = { fullTime: "Full Time", casual: "Casual" };

function Field({ label, value, mono = false }) {
    return (
        <div className="flex items-start justify-between py-3 border-b border-gray-50 dark:border-gray-700/50 last:border-0 gap-6">
            <dt className="text-sm text-gray-400 dark:text-gray-400 shrink-0 w-44">{label}</dt>
            <dd className={`text-sm text-gray-800 dark:text-gray-200 text-right ${mono ? 'font-mono' : ''}`}>
                {value || <span className="text-gray-300">—</span>}
            </dd>
        </div>
    );
}

function ClientData({ client }) {
    return (
        <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm overflow-hidden">
            <div className="px-5 py-4 border-b border-gray-100 dark:border-gray-700">
                <div className="flex items-center gap-2 flex-wrap">
                    <h2 className="text-base font-semibold text-gray-900 dark:text-gray-50">
                        {client?.otherNames} {client?.surname}
                    </h2>

                    {client?.isVerified ? (
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium bg-blue-50 text-blue-600 border border-blue-100 rounded-full">
                            <HugeiconsIcon icon={CheckmarkCircle01Icon} size={11} />
                            Verified
                        </span>
                    ) : (
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium bg-gray-100 text-gray-500 border border-gray-200 rounded-full">
                            Not Verified
                        </span>
                    )}

                    {client?.failedVerification && (
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium bg-red-50 text-red-600 border border-red-100 rounded-full">
                            <HugeiconsIcon icon={Cancel01Icon} size={11} />
                            Failed NIA Verification
                        </span>
                    )}

                    {client?.isDisabled && (
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium bg-red-50 text-red-600 border border-red-100 rounded-full">
                            Banned
                        </span>
                    )}
                </div>
                <p className="text-xs text-gray-400 dark:text-gray-500 mt-0.5">Personal details and application</p>
            </div>

            <div className="px-5 py-2">
                <dl>
                    <Field label="First Name" value={client?.otherNames} />
                    <Field label="Last Name" value={client?.surname} />
                    <Field label="Phone / Network" value={`${client?.phone || '—'} / ${client?.network || '—'}`} />
                    <Field label="Email Address" value={client?.email} />
                    <Field label="Gender" value={client?.gender ? client.gender.charAt(0).toUpperCase() + client.gender.slice(1) : null} />
                    <Field label="Date of Birth" value={dateToHumanFormat(client?.dob)} />
                    <Field label="Place of Birth" value={client?.placeOfBirth} />
                    <Field label="Nationality" value={client?.nationality ? client.nationality.charAt(0).toUpperCase() + client.nationality.slice(1) : null} />
                    <Field label="ID Type / Number" value={`${client?.idType || '—'} / ${client?.idNumber || '—'}`} />
                    <Field label="Residential Address" value={client?.address} />
                    <Field label="Digital Address" value={client?.digitalAddress} mono />
                    <Field label="Nearest Landmark" value={client?.nearestLandmark} />
                    <Field label="Educational Level" value={client?.education} />
                    <Field label="Occupation" value={client?.occupation} />
                    <Field label="Employment Nature" value={employmentLabels[client?.employNature] || client?.employNature} />
                    <Field label="Account Created By" value={client?.tag ? client.tag.charAt(0).toUpperCase() + client.tag.slice(1) : null} />

                    <div className="py-3">
                        <dt className="text-sm text-gray-400 dark:text-gray-400 mb-2">Uploaded IDs</dt>
                        <dd>
                            {client?.uploadedFiles && client.uploadedFiles.length > 0 ? (
                                <ul className="divide-y divide-gray-100 dark:divide-gray-700 rounded-lg border border-gray-100 dark:border-gray-700 overflow-hidden">
                                    {client.uploadedFiles.map((file, index) => (
                                        <PreviewFile key={index} file={file} phone={client?.phone} />
                                    ))}
                                </ul>
                            ) : (
                                <span className="text-sm text-gray-300">No files uploaded</span>
                            )}
                        </dd>
                    </div>
                </dl>
            </div>
        </div>
    );
}

export default ClientData;
